import React from 'react';
import { View } from 'react-native';
import { GroupMessage } from '../components/GroupList';
import { MessageHistory } from '../components/MessageHistory';
import { CanvasChatComponentProvider } from '../context';
import { chatComponentStyles } from '../style';
import { ChatComponentProps } from '../type';
import {
  isPCView,
  PC_WIDTH_GROUP_MESSAGE_VIEW,
} from '../../../ChatComponent/utils';

const CanvasViewContent = (props: ChatComponentProps) => {
  const styled = chatComponentStyles(props);
  if (isPCView(props.width)) {
    return (
      <View style={styled.pcContainer}>
        <View
          style={{
            width: PC_WIDTH_GROUP_MESSAGE_VIEW,
          }}
        >
          <GroupMessage />
        </View>
        {/* Take all remaining width; minWidth:0 lets long messages wrap instead of overflowing */}
        <View
          style={{
            flex: 1,
            minWidth: 0,
          }}
        >
          <MessageHistory />
        </View>
      </View>
    );
  }
  return <GroupMessage />;
};
export const CanvasView = (props: ChatComponentProps) => {
  const styled = chatComponentStyles(props);
  return (
    <CanvasChatComponentProvider {...props}>
      <View style={styled.container} nativeID="CanvasView">
        <CanvasViewContent {...props} />
      </View>
    </CanvasChatComponentProvider>
  );
};
